/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Navbar,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
  Col,
  Row,
  Table,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import * as Icon from "react-feather";
import {
  ToggleMiniSidebar,
  ToggleMobileSidebar,
} from "../../store/customizer/CustomizerSlice";
import phonepe from "../../assets/images/icons/phonepe.png";
import gpay from "../../assets/images/icons/gpay.png";
import paytm from "../../assets/images/icons/paytm.png";
import upi from "../../assets/images/icons/upi.png";
import { logout } from "../../slices/authSlice/userSilce";
import { fetchData } from "../../slices/authSlice/dataSlice";
import user1 from "../../assets/images/users/user1.jpg";
import ProfileDD from "./ProfileDD";
import ReactStrapModal from "../../components/common/reactStrapModal";
import CreditSelfAdmin from "../../views/Admin/ManageCreditDetails/CreditSelfAdmin";
import NavBtnImg from "../../assets/images/admin/dash_mob.svg";
import LogoImg from "../../assets/images/logos/logo-w.png";
import { Modal } from "antd";
import { consoleEnableKey } from "../../components/common/constant";
import _ from "lodash";
import { GetDataActiveDeactive } from "../../slices/admin/Management/managementSlice";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDarkMode = useSelector((state) => state.customizer.isDark);
  const topbarColor = useSelector((state) => state.customizer.topbarBg);
  const { user: currentUser } = useSelector((state) => state.user);
  const { token: Usertoken } = useSelector((state) => state.user);
  const baseB4 = "data:image/jpeg;base64,";
  const { consoleEnable } = useSelector((state) => state.managementSlice);
  const isMiniSidebar = useSelector((state) => state.customizer.isMiniSidebar);
  const [QRimage] = useState();
  const [UPIID] = useState();
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openWalletModal, setOpenWalletModal] = useState(false);

  useEffect(() => {
    dispatch(fetchData({ Usertoken, currentUser }));
  }, [dispatch]);

  const loginData = useSelector((state) => state.data.items);

  const handleLogoutClick = () => {
    Modal.confirm({
      title: "Logout",
      content: "Are you sure to Logout?",
      onCancel() {},
      onOk() {
        window.addEventListener("beforeunload", () => {
          dispatch(logout());
        });
        navigate("/login", { replace: true });
        window.location.reload();
      },
    });
  };

  const toggle = () => {
    setModal(!modal);
  };

  const getConsoleEnableDat = () => {
    if (Usertoken && currentUser) {
      const masterKey = consoleEnableKey;
      dispatch(GetDataActiveDeactive({ currentUser, Usertoken, masterKey }))
        .unwrap()
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (_.isEmpty(consoleEnable)) {
      getConsoleEnableDat();
    }
  }, [Usertoken, consoleEnable]);

  const isAdminRole = ["1", "2", "8"].includes(currentUser.role);

  const roleWelcomeText = {
    1: "Dashboard - WELCOME, Admin Dashboard!",
    4: "Dashboard - WELCOME, Super Distributor Dashboard!",
    5: "Dashboard - WELCOME, Distributor Dashboard!",
    6: "Dashboard - WELCOME, Retailer Dashboard!",
  };

  return (
    <>
      <Navbar
        dark={!isDarkMode}
        light={isDarkMode}
        expand="lg"
        className={`${isAdminRole ? "topbarAdmin admin_head_bg" : "topbar"} ${
          ["1", "2"].includes(currentUser.role) ? "px-md-2" : ""
        }`}
      >
        <div className="dashboard-header">
          <div className="left-content">
            {currentUser.role === "6" ? (
              <img src={LogoImg} style={{ height: "50px" }} alt="" />
            ) : null}

            {["4", "5"].includes(currentUser.role) ? (
              <Button
                className="toggle-btn"
                onClick={() => dispatch(ToggleMiniSidebar())}
              >
                <i
                  className={`fas ${
                    isMiniSidebar ? "fa-angle-right" : "fa-angle-left"
                  }`}
                />
              </Button>
            ) : null}

            <span className="welcome-text">
              {roleWelcomeText[currentUser.role] || ""}
            </span>
          </div>

          <div className="right-content">
            {/* {["1", "4", "5"].includes(currentUser.role) ? ( */}
            {!currentUser?.password_Reset && ["1"].includes(currentUser.role) ? (
              <span
                className="d-md-block  mr-3"
                onClick={() => setOpenWalletModal(true)}
              >
                <i className="bi bi-wallet2 fs-3" />
              </span>
            ) : null}

            {!currentUser?.password_Reset && currentUser.role === "6" ? (
              <span className="wallet-style">
                AEPS Wallet : {`\u20B9`}{" "}
                {loginData ? loginData.aepS_Wallet_Balance : "0.00"}
              </span>
            ) : null}

            {!currentUser?.password_Reset && <span className="wallet-style">
              Main Wallet : {`\u20B9`}
              {loginData ? loginData.main_Wallet_Balance : "0.00"}
            </span>}

            <UncontrolledDropdown>
              <DropdownToggle className="logout-btn">
                <img src={user1} alt="user" />
                <span className="user-name">
                  {loginData ? loginData.firstName : ""}{" "}
                  {loginData ? loginData.lastName : ""}
                </span>
                <Icon.ChevronDown size={15} color="#3fa2db" />
              </DropdownToggle>
              <DropdownMenu className="logout-card">
                {!currentUser?.password_Reset && <ProfileDD />}
                <Button color="danger" size="sm" onClick={handleLogoutClick}>
                  Logout
                </Button>
              </DropdownMenu>
            </UncontrolledDropdown>
            {!currentUser?.password_Reset && <Button
              color={topbarColor}
              className="d-sm-block d-lg-none border-0 mx-1 hov-dd"
              onClick={() => dispatch(ToggleMobileSidebar())}
            >
              <img src={NavBtnImg} width={24} alt="" />
            </Button>}
          </div>
        </div>
      </Navbar>

      {modal ? (
        <ReactStrapModal
          modal={modal}
          setModal={() => toggle(null)}
          isHeader
          isToggle
          title="UPI Collection"
          className="editModelDmt"
        >
          <Row className="row">
            <Col md="4">
              <img
                src={baseB4 + QRimage}
                alt="123"
                style={{ width: "150px", border: "1px solid #dfe2e6" }}
              />
            </Col>
            <Col md="8" className="mt-0">
              <Table className="table-bordered">
                <thead>
                  <tr>
                    <td className="text-nowrap text-black">Name </td>
                    <td>
                      {loginData.firstName}
                      {loginData.lastName}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-nowrap text-black">UPI ID </td>

                    <td>{UPIID}</td>
                  </tr>
                </thead>
              </Table>
              <Row>
                <img src={phonepe} alt="phonepe" style={{ width: "60px" }} />
                <img src={gpay} alt="gpay" style={{ width: "60px" }} />
                <img src={upi} alt="upi" style={{ width: "60px" }} />
                <img src={paytm} alt="paytm" style={{ width: "60px" }} />
              </Row>
            </Col>
          </Row>
        </ReactStrapModal>
      ) : null}

      {openWalletModal && (
        <ReactStrapModal
          modal={openWalletModal}
          setModal={() => setOpenWalletModal(false)}
          isHeader
          isToggle
          title="Self TopUp"
          className="editModelDmt"
          size="sm"
          styles={window.innerWidth >= 992 ? { width: "400px" } : {}}
        >
          <CreditSelfAdmin
            setOpenWalletModal={() => setOpenWalletModal(false)}
          />
        </ReactStrapModal>
      )}
    </>
  );
};

export default Header;
